var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80615 9.85547C2.80615 5.99911 5.94979 2.85547 9.80615 2.85547C13.6625 2.85547 16.8062 5.99911 16.8062 9.85547C16.8062 13.7118 13.6625 16.8555 9.80615 16.8555C5.94979 16.8555 2.80615 13.7118 2.80615 9.85547ZM10.8687 12.8555V10.918H12.8062C13.3898 10.918 13.8687 10.4391 13.8687 9.85547C13.8687 9.27183 13.3898 8.79297 12.8062 8.79297H10.8687V6.85547C10.8687 6.27183 10.3898 5.79297 9.80615 5.79297C9.22251 5.79297 8.74365 6.27183 8.74365 6.85547V8.79297H6.80615C6.22251 8.79297 5.74365 9.27183 5.74365 9.85547C5.74365 10.4391 6.22251 10.918 6.80615 10.918H8.74365V12.8555C8.74365 13.4391 9.22251 13.918 9.80615 13.918C10.3898 13.918 10.8687 13.4391 10.8687 12.8555Z",
    fill: "#22222A",
    stroke: "#22222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcircle);
export default __webpack_public_path__ + "static/media/addcircle.984eebe7702bcd3dd0f26c651325a230.svg";
export { ForwardRef as ReactComponent };